import React, { useEffect, useState, useContext } from "react";
import { getDailySalesReport, getSalesReport } from "../../../Utility/Api";
import { useNavigate } from "react-router-dom";
import {
  getFormattedCurrentDate2,
  NaviGate,
  shop_id,
} from "../../../Utility/function";
import { WarehouseContext } from "../../../Utility/UserContext";
import "./table.css";
import DailysalesReportDetails from "./DailysalesReportDetails";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable"; // Ensure autoTable is imported

const SalesReport = () => {
  const navigate = useNavigate();
  const { showLoader, hideLoader } = useContext(WarehouseContext);
  const [data, setData] = useState([]);
  const [fromDate, setFromDate] = useState(getFormattedCurrentDate2());
  const [toDate, setToDate] = useState(getFormattedCurrentDate2());
  const [page, setpage] = useState(1);

  useEffect(() => {
    fetchData();
  }, [fromDate, toDate]);

  const fetchData = async () => {
    try {
      showLoader();
      var filter = `from_date=${fromDate}&to_date=${toDate}&shop_id=${shop_id}`;
      const response = await getDailySalesReport(filter);
      if (response.data && response.data.data) {
        setData(response.data.data);
      }
      hideLoader();
    } catch (error) {
      hideLoader();
      console.error("Error fetching order data:", error);
    }
  };

  const handleFilter = (e) => {
    e.preventDefault();
    fetchData();
  };

  const [DailySalesReport, setDailySalesReport] = useState();
  const handleView = async (date) => {
    setDailySalesReport(date);

    setpage(2);
  };

  const exportToExcel = async (date) => {
    // console.log(date);
    try {
      var filter = `from_date=${date}&to_date=${date}&shop_id=${shop_id}`;
      const response = await getSalesReport(filter);
      const data = response.data.data;

      let totalSalesRO = 0;
      let totalUnpaid = 0;
      let totalPrice = 0;

      const exportData = data.map((item) => {
        totalSalesRO += item.total;
        totalUnpaid += item.remaining;
        totalPrice += item.total - item.remaining;

        return [
          item.unique_id,
          item.customer_name,
          item.total,
          item.remaining,
          (item.total - item.remaining).toFixed(),
        ];
      });

      // Add total row
      exportData.push([
        "Total",
        "", // Empty for customer name
        data
          .reduce((acc, item) => acc + parseFloat(item.total || 0), 0)
          .toFixed(3),
        data
          .reduce((acc, item) => acc + parseFloat(item.remaining || 0), 0)
          .toFixed(3),
        (
          data.reduce((acc, item) => acc + parseFloat(item.total || 0), 0) -
          data.reduce((acc, item) => acc + parseFloat(item.remaining || 0), 0)
        ).toFixed(3),
      ]);

      const doc = new jsPDF();
      doc.text(`Daily Sales Report - ${date}`, 14, 10);

      autoTable(doc, {
        head: [
          [
            "Master ID",
            "Customer Name",
            "Sales RO",
            "Unpaid on Sales",
            "Price",
          ],
        ],
        body: exportData,
        startY: 20,
        styles: { fontSize: 10 },
        footStyles: { fillColor: [211, 211, 211] }, // Light gray background for total row
      });

      doc.save(`Daily Sales Report - ${date}.pdf`);
    } catch (error) {
      console.error("Error fetching order data:", error);
    }
  };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure two digits
    const day = String(date.getDate()).padStart(2, "0"); // Ensure two digits
    return `${year}-${month}-${day}`;
  };

  const handleDateFilter = (type) => {
    const currentDate = new Date();
    let startDate = new Date();

    if (type === "week") {
      startDate.setDate(currentDate.getDate() - 7); // Last week
    } else if (type === "month") {
      startDate.setMonth(currentDate.getMonth() - 1); // Last month
    }

    setFromDate(formatDate(startDate));
    setToDate(formatDate(currentDate));
  };

  const handleSetpage = () => {
    setpage(1);
  };

  return (
    <div className="page-wrappers">
      <div className="page-content py-1">
        {page == 1 && (
          <>
            {/* <NaviGate /> */}
            {/* <h6 className="mt-3 text-uppercase">Daily Sales Reports</h6> */}

            <form onSubmit={handleFilter} className="card p-4 shadow-sm">
              <div className="row g-3 justify-content-end align-items-center">
                <h5 className="text-uppercase mb-0">Daily Sales Report</h5>

                <div className="col-md-2 ">
                  <div className="d-flex column-gap-2 ">
                    <button
                      className="btn btn-primary px-2 py-1 rounded-1 font-weight-2"
                      style={{ fontSize: "13px", width: "max-content" }}
                      onClick={() => handleDateFilter("week")}
                    >
                      Last Week
                    </button>
                    <button
                      className="btn btn-primary px-2 py-1 rounded-1 font-weight-2"
                      style={{ fontSize: "13px", width: "max-content" }}
                      onClick={() => handleDateFilter("month")}
                    >
                      Last Month
                    </button>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-floating">
                    <input
                      type="date"
                      className="form-control"
                      id="fromDate"
                      value={fromDate}
                      max={toDate}
                      onChange={(e) => setFromDate(e.target.value)}
                    />
                    <label htmlFor="fromDate">From Date</label>
                  </div>
                </div>

                {/* To Date */}
                <div className="col-md-2">
                  <div className="form-floating">
                    <input
                      type="date"
                      className="form-control"
                      id="toDate"
                      value={toDate}
                      min={fromDate}
                      onChange={(e) => setToDate(e.target.value)}
                    />
                    <label htmlFor="toDate">To Date</label>
                  </div>
                </div>
              </div>

              <div className="table-responsive text-center my-2 w-100 position-relative">
                <table className="table table-striped table-sm table-bordered">
                  <thead className="table-dark">
                    <tr>
                      <th>S.No</th>
                      <th>Date</th>
                      <th>Total Sales</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.sale_date}</td>
                        <td>RO {item.total_sales?.toFixed()}</td>
                        <td style={{ width: "250px" }}>
                          <div className="d-flex justify-content-around">
                            <button
                              className="btn btn-primary  btn-sm "
                              onClick={() => handleView(item.sale_date)}
                            >
                              View
                            </button>
                            <button
                              className="btn btn-primary  btn-sm "
                              onClick={() => exportToExcel(item.sale_date)}
                            >
                              Export as PDF
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </form>
          </>
        )}
        {page == 2 && (
          <>
            <div className="mb-2"></div>
            <DailysalesReportDetails
              date={DailySalesReport}
              handleSetpage={handleSetpage}
            />
          </>
        )}
      </div>
      {/* {Array.isArray(DailySalesReport) && DailySalesReport.length >0 && (
        <div className="container mt-4">
          <h2 className="text-center mb-4">Daily Sales Report - March 19, 2025</h2>
          <div className="table-responsive">
            <table className="table table-striped table-bordered table-hover">
              <thead className="table-dark">
                <tr>
                  <th>Master ID/User</th>
                  <th>Customer Name</th>
                  <th>Sales (RO)</th>
                  <th>Unpaid on Sales (RO)</th>
                  <th>Price (INR)</th>
                </tr>
              </thead>
              <tbody>
                {DailySalesReport && DailySalesReport.map(item => (
                  <tr>
                    <td>{item.unique_id}</td>
                    <td>{item.customer_name}</td>
                    <td>{item.total}</td>
                    <td>{item.remaining}</td>
                    <td>{(item.total - item.remaining).toFixed()}</td>
                  </tr>
                ))}
                <tr className="table-primary fw-bold">
                  <td colSpan={2} className="text-end">Total</td>
                  <td colSpan={1} className="text-end">
                    RO {DailySalesReport.reduce((acc, item) => acc + parseFloat(item.total || 0), 0).toFixed(3)}
                  </td>
                  <td>
                    RO {DailySalesReport.reduce((acc, item) => acc + parseFloat(item.remaining || 0), 0).toFixed(3)}
                  </td>
                  <td colSpan={1}>
                    RO {(
                      DailySalesReport.reduce((acc, item) => acc + parseFloat(item.total || 0), 0) -
                      DailySalesReport.reduce((acc, item) => acc + parseFloat(item.remaining || 0), 0)
                    ).toFixed(3)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
    )} */}
    </div>
  );
};

export default SalesReport;
